import { withNamespaces } from "react-i18next";
import { Col, Row } from "reactstrap";
import Select from 'react-select';
import FrameworkHandler from "../../frameworks";

const ListControls = ({
    t,
    ControlsFrameworksOptions,
    controlType,
    setControlType
}) => {
    return (
        <Row>
            <Col sm="12" md="12" lg="4" className="mb-3 mt-3">
                <Select
                    name='type'
                    classNamePrefix='select2-selection'
                    options={ControlsFrameworksOptions}
                    value={controlType}
                    placeholder={t('Filter by Type')}
                    onChange={setControlType}
                    styles={{
                        container: (baseStyles) => ({
                            ...baseStyles,
                            width: '320px'
                        })
                    }}
                />
            </Col>

            {controlType?.value ? (
                <FrameworkHandler
                    section="list"
                    frameworkKey={controlType.value}
                />
            ) : null}
        </Row>
    )
};

export default withNamespaces()(
    ListControls
);